// @ts-nocheck — Phase 4 lib extraction; types added when consumers tighten
/**
 * src/lib/channels.ts — HubSpot channel + stage label dictionaries.
 *
 * Pulled out of src/legacy/app.tsx (module-top consts ~line 746) during
 * Phase 4 sub-step 8 (NotificationBell extraction). Two composed
 * components consume these now: DealsView and NotificationBell. The
 * legacy app.tsx Dashboard also references them for the deal-event
 * notification logic — for now we keep duplicate consts in app.tsx
 * pointing at the same shapes; future cleanup imports from this lib.
 */

export const CHANNEL_LABELS = {
  gtmActual:       { it: "GTM",       en: "GTM",       color: "var(--lilac-700)" },
  partnerActual:   { it: "Partner",   en: "Partner",   color: "var(--lilac-600)" },
  selfServeActual: { it: "Self",      en: "Self",      color: "var(--lilac-500)" },
  setupUpsell:     { it: "Setup",     en: "Setup",     color: "var(--ae-500)" },
  upsellPipeline:  { it: "Upsell",    en: "Upsell",    color: "var(--good)" },
  gtmCommitted:    { it: "Committed", en: "Committed", color: "var(--proj)" },
  // Italy deals owned by people outside the Italy team. Visible for tracking
  // but NOT tagged as GTM — keeps Marco's numbers honest.
  otherActual:     { it: "Other",     en: "Other",     color: "var(--ink-3)" },
  otherCommitted:  { it: "Other",     en: "Other",     color: "var(--ink-3)" },
  churnAbs:        { it: "Churn",     en: "Churn",     color: "var(--warn)" },
};

export const STAGE_LABELS = {
  "3060983000": { name: "Closed Won",       isClosedWon: true },
  "3060983001": { name: "Closed Lost",      isClosedLost: true },
  "3060982999": { name: "Committed",        isCommitted: true },
  "2918363330": { name: "Partner CW",       isClosedWon: true },
  "4862860520": { name: "Strategic CW",     isClosedWon: true },
  "2162853084": { name: "Self New Account", isClosedWon: true },
  "3230917880": { name: "Setup Purchased",  isClosedWon: true },
  "3230918844": { name: "Setup In Progress",isClosedWon: true },
  "3230918845": { name: "Setup Completed",  isClosedWon: true },
  "4897341647": { name: "Upsell Won",       isClosedWon: true },
};

export const stageDisplay = (stageId) => STAGE_LABELS[stageId]?.name || stageId;
